import { type UseNodeAssetsChannelOptions, useNodeAssetsChannel } from '@/hooks/websocket/useNodeAssetsChannel';

export const useFolderChannel = (folderId: string | undefined, options: UseNodeAssetsChannelOptions = {}): void => {
  useNodeAssetsChannel(folderId ? `folder.${folderId}` : undefined, options);
};
